export default "__VITE_ASSET__DhG9dvU9__"